module.exports = __webpack_public_path__ + "img/img-26.4d773e89.png";